// TODO: we can think about splitting this file up for better organisation
import { ReactNode } from "react";

export const ICON_BINDING_SOURCE = "icon-binding-source";
export const SECTION_BREAK = "section-break";
export const SECTION_BREAK_SMALL = "section-break-small";
export const TEXT_COLOR = "text-color";
export const TEXT_STYLE = "text-style";
export const TEXT_ALIGN = "text-alignment";
export const ICON_COLOR = "icon-color";
export const CALCULATE_DELAY = "calculate-delay";
export const LOADER_COLOR = "loader-color";
export const LOADER_SIZE = "loader-size";
export const MATERIAL_ICONS_USED = "material-icons-used";
export const ALERT_SEVERITY = "alert-severity";
export const ALERT_TEXT = "alert-text";
export const BUTTON_TEXT = "button-text";
export const BUTTON_VARIANT = "button-variant";
export const BACKGROUND_COLOR = "background-color";
export const MINIMUM_DELAY_IN_HOURS = 3;
export const REPLACEMENT_AMOUNT = "replacementAmount";

export enum MaterialColors {
  Primary = "primary",
  Secondary = "secondary",
  Error = "error",
  Info = "info",
  Success = "success",
  Warning = "warning",
}

export enum AlertColors {
  Info = "info",
  Error = "error",
  Warning = "warning",
  Success = "success",
}

export enum AlignItems {
  FlexStart = "flex-start",
  Center = "center",
  FlexEnd = "flex-end",
}

export enum MaterialIconsPack {
  plane = "Flight",
  train = "DirectionsRailway",
  bus = "DirectionsBus",
}

export interface Flow {
  id: string;
  key: string;
  category: string;
  description: {} | null;
  name: string;
  version: number;
  resource: string;
  deploymentId: string;
  diagram: {} | null;
  suspended: false;
  tenantId: {} | null;
  versionTag: {} | null;
  historyTimeToLive: {} | null;
  startableInTasklist: true;
}

export interface ActiveInstance {
  id: string;
  parentActivityInstanceId: {} | null;
  activityId: string;
  activityType: string;
  processInstanceId: string;
  processDefinitionId: string;
  childActivityInstances: ActiveInstance[];
  childTransitionInstances: string[];
  executionIds: string[];
  activityName: string;
  incidentIds: string[];
  incidents: string[];
  name: string;
}

export interface Field {
  id: string;
  key: string;
  type: string;
  label: string;
  layout?: FieldLayout;
  properties: FieldProperties;
  action?: string;
  text?: string;
  disabled?: boolean;
  defaultValue?: string;
  validate?: FieldValidations;
  valuesKey?: string;
  values?: Array<FieldValues | FieldRadioOption | FieldSelectOption>;
}

interface FieldProperties {
  redirectUrl?: string;
  subtype?: FieldSubtype;
  requiredInputVariables?: string;
  source?: string;
  icon?: string;
  content?: AccordionContent;
  variant?: ButtonVariant;
  isEditable?: boolean;
  alignItems?: AlignItems;
  [IconPosition.IconBefore]?: string;
  [IconPosition.IconAfter]?: string;
  [ICON_COLOR]?: MaterialColors;
  [MATERIAL_ICONS_USED]?: boolean;
  addBtnText?: string;
  removeBtnText?: string;
  action?: FieldAction;
  navigationAction?: string;
  group?: string;
  fullWidth?: string;
  [TEXT_COLOR]?: MaterialColors;
  [TEXT_STYLE]?: TextStyle;
  [TEXT_ALIGN]?: TextAlign;
  [LOADER_COLOR]?: MaterialColors;
  [LOADER_SIZE]?: number;
  [SECTION_BREAK]?: boolean;
  [SECTION_BREAK_SMALL]?: boolean;
  [ICON_BINDING_SOURCE]?: RadioIconsType;
  iconSize?: IconSize;
  [CALCULATE_DELAY]?: string;
  [FieldVisibilityRuleType.HideIf]?: string;
  [RedirectSource.RedirectionLink]?: string;
  [RedirectSource.RedirectionLinkVariable]?: string;
  required?: boolean;
  rows?: number;
  minRows?: number;
  maxRows?: number;
  placeholderText?: string;
  orientation?: FieldOrientation;
  [DateTimeValidationType.After]?: string;
  validationKey?: string;
  [ALERT_SEVERITY]?: AlertColors;
  [ALERT_TEXT]?: string;
  errorTranslationKey?: string;
  [BUTTON_TEXT]?: string;
  [BUTTON_VARIANT]?: ButtonVariant;
  [BACKGROUND_COLOR]?: string;
  disableFutureDates?: boolean;
  subtext?: string;
  isInvalidForm?: string | undefined;
  amount?: number;
  unitLabel?: string;
  version?: string;
  [DocumentProperties.documentType]?: string;
  [DocumentProperties.documentSubtype]?: string;
  animationFile?: string;
  loadingTimeInMs?: number;
  signal?: string;
  flipped?: boolean;
  brandBased?: boolean;
}

export enum OutputArrayTypes {
  FieldGroup = "group",
  Navigation = "navigation",
}

export type FieldGroup = {
  [key in OutputArrayTypes]?: Field[];
};

export type RowFieldGroup = Field[];

export enum FieldGroupType {
  AdditionalPassenger = "additional-passenger",
  Stopover = "stopover",
  MultipleCheckbox = "multiple-checkbox",
  AdditionalPassengerSignatures = "additional-passenger-signatures",
  WaitingList = "waiting-list",
}

export interface TextVariantProps {
  color?: MaterialColors | string;
  text: string;
  textAlign?: TextAlign;
  variant: HeadingLevel;
  fontWeight?: number;
  iconPosition?: IconPosition;
  isJumbotron?: boolean;
  variables?: string;
  isTextSelectable?: boolean;
  alignItems?: AlignItems;
}

export interface IconProps {
  iconSrc?: string;
  iconName?: string;
  iconColor?: MaterialColors;
  iconCustomColor?: string;
  iconSize?: IconSize;
  canBeFilled?: boolean;
}

export enum FieldOrientation {
  Horizontal = "horizontal",
  HorizontalFullWidth = "horizontal-full-width",
}

export enum RedirectSource {
  RedirectionLink = "redirection-link",
  RedirectionLinkVariable = "redirection-link-variable",
}

export enum AccordionContent {
  FlightNumber = "flight-number",
  FlightProblems = "flight-problems",
  CompensationInfo = "compensation-info",
}

export enum ButtonVariant {
  Contained = "contained",
  Outlined = "outlined",
  Text = "text",
  CtaContained = "ctaContained",
}

export enum RadioIconsType {
  FlightProblems = "flight-problems",
  TransportationMode = "transportation-mode",
}

export enum TextStyle {
  Bold = "bold",
}

export enum TextAlign {
  Left = "left",
  Center = "center",
  Right = "right",
}

export enum IconPosition {
  IconBefore = "icon-before",
  IconAfter = "icon-after",
}

export enum IconSize {
  Small = "12",
  Medium = "24",
  Large = "32",
}

export enum FieldAction {
  Submit = "submit",
  CancelStep = "cancel-step",
  SkipStep = "skip-step",
  Reset = "reset",
  SubmitNoValidation = "submit-no-validation",
}

export enum FieldVisibilityRuleType {
  HideIf = "hide-if",
}

export enum DateTimeValidationType {
  After = "datetimeValidation.after",
}

export enum HeadingLevel {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  Subtitle1 = "subtitle1",
  Body1 = "body1",
  Body2 = "body2",
}

export enum FlightProblems {
  OnTime = "ON_TIME",
  Delayed = "DELAYED",
  Cancelled = "CANCELLED",
  Rerouted = "REROUTED",
  Returned = "RETURNED",
  DeniedBoarding = "DENIED_BOARDING",
  MissedConnection = "MISSED_CONNECTION",
  Other = "OTHER",
}

export type FlightProblem = keyof typeof FlightProblems;

interface FieldValidations {
  required?: boolean;
  regex?: string;
  min?: number;
  max?: number;
  minDate?: Date;
  maxDate?: Date | MaxDateType;
  minLength?: number;
  maxLength?: number;
}

export enum MaxDateType {
  Today = "today",
}

export interface FieldValues {
  icon?: string;
  label: string;
  value: string;
}

interface FieldLayout {
  row?: string;
}

export type FieldSelectOption = FieldValues;
export type FieldRadioOption = FieldValues;

export interface AirData {
  iata: string;
  name: string;
}

export interface AirportData extends AirData {}

export interface AirlineData extends AirData {}

export interface AddressData {
  street: string;
  houseNumber: string;
  houseNumberAddition: string | null;
  houseNumberFull: string;
  postcode: string;
  district: string;
  city: string;
  objectStatus: string;
  areaWas: string;
}

export interface BannerProps {
  originAirportData: AirportData;
  destinationAirportData: AirportData;
  selectedFlightDate: string | null;
  setSelectedFlightDate: (val: string) => void;
}

export enum FieldType {
  Text = "text",
  TextField = "textfield",
  TextArea = "textarea",
  Number = "number",
  Select = "select",
  Radio = "radio",
  Checkbox = "checkbox",
  Checklist = "checklist",
  TagList = "taglist",
  Button = "button",
}

export enum FieldSubtype {
  // Text subtypes
  Heading = "heading",
  Title = "title",
  Subtitle = "subtitle",
  Paragraph = "paragraph",
  Jumbotron = "jumbotron",
  // Text custom subtypes
  Accordion = "accordion",
  CustomerContactInfo = "customer-contact-info",
  Redirect = "redirect",
  Unsubscribe = "unsubscribe",
  UnsubscribeError = "unsubscribeError",
  // Textfield custom subtypes
  TextArea = "textarea",
  Autosuggest = "autosuggest",
  Stopover = "stopovers-input",
  StopoverWithAlternativeTransport = "stopovers-transport-mode-input",
  Date = "date",
  Time = "time",
  DateTime = "datetime",
  FlightSelector = "flight-selector",
  TransportLegInput = "transport-leg-input",
  FileUpload = "file-upload",
  Signature = "signature",
  PassengersOutput = "passengers-output",
  SelectNumber = "select-number",
  FlightSummary = "flight-summary",
  MieteCaseSummary = "case-summary",
  NextSteps = "next-steps",
  MissingSteps = "missing-steps",
  FlightCard = "flight-card",
  VoucherCode = "voucher-code",
  Loader = "loader",
  InfoBoxTicketRefund = "info-box-ticket-refund",
  Alert = "alert",
  SelectMultiLegProblem = "flight-incident-input",
  CopyText = "copy-and-share",
  Telephone = "telephone",
  DocumentPreviewLink = "documentPreviewLink",
  AddPhoneNumber = "add-phone-number",
  ColumnCard = "column-card",
  CurrencyInput = "currency-input",
  CaseCreationLoader = "case-creation-loader",
  LottieAnimation = "lottie-animation",
}

export enum PageViewTitle {
  Airports = "step-01-airports",
  OutflowMultileg = "outflow-to-standard-multileg",
  OutflowFlightSelection = "outflow-to-standard-flight-selected",
  CustomerSignature = "customer-signature",
  AdditionalPassengerSignatures = "step-post-case-01a-signature-additional-passengers",
  UploadBookingConfirmation = "step-post-case-02-document-upload",
  ShowNextSteps = "step-post-case-06-next-steps",
}

export enum SkippedStepTypes {
  EnterBookingNumber = "EnterBookingNumber",
  EnterSignature = "EnterSignature",
  UploadBookingConfirmation = "UploadBookingConfirmation",
  goToAdditionalSignaturePage = "goToEnterAdditionalSignaturePage",
}

export interface TaskData {
  task: {
    id: string;
    name: string;
    taskDefinitionKey: string;
  };
  components: Field[];
  extensionProperties: TaskExtensionProperties;
}

interface TaskExtensionProperties {
  progressPercentage?: string;
  stepTitle?: string;
  displayStepTitle?: string;
  progressText?: string;
  progressMaterialColors?: MaterialColors;
  progressTextColor: MaterialColors;
  eventsToExpose?: string;
}

export interface ProcessData {
  links: [
    {
      method: string;
      href: string;
      rel: string;
    }
  ];
  id: string;
  definitionId: string;
  businessKey: string;
  caseInstanceId: null;
  ended: boolean;
  suspended: boolean;
  tenantId: string | null;
}

export type ReactComponentContainer = {
  children: ReactNode;
  brandName: Brand;
};

export enum Brand {
  DEFAULT = "flightright",
  ALLRIGHT = "allright",
  CHEVALIER = "kanzlei-chevalier",
  FREEM = "gofreem",
  FLIGHTRIGHT = "flightright",
  FLUGRECHT = "flugrecht",
  FLYGHJALP = "flyghjalp",
  FLYHJAELP = "flyhjaelp",
  FLYHJELP = "flyhjelp",
  LENTOAPU = "lentoapu",
  REFUNDMORE = "refundmore",
}

export type BrandType = (typeof Brand)[keyof typeof Brand];

export enum BrandFamily {
  DEFAULT = "flightright",
  FLIGHTRIGHT = "flightright",
  FLUGRECHT = "flugrecht",
  FLYHJAELP = "flyhjaelp",
  ALLRIGHT = "allright",
  CHEVALIER = "kanzlei-chevalier",
}

export interface BrandDetails extends BrandName {
  brandFamily: BrandFamily;
}

export enum TranslationTenant {
  DEFAULT = "flightright",
  FLIGHTRIGHT = "flightright",
  FLUGRECHT = "flugrecht",
  FLYHJAELP = "flyhjaelp",
  ALLRIGHT = "allright",
  MIETE = "miete",
  ARBEITSRECHT = "arbeitsrecht",
}

export enum Domains {
  NET = "net",
  COM = "com",
  UK = "uk",
  DE = "de",
  AT = "at",
  ES = "es",
  FR = "fr",
  DK = "dk",
  SE = "se",
  NO = "no",
  FI = "fi",
  DEFAULT = "default",
}

export enum Languages {
  EN = "en",
  DE = "de",
  ES = "es",
  FR = "fr",
  DA = "da",
  DK = "dk", // the language should be DA, but "dk" is expected by CMA to get the right country
  SV = "sv",
  NO = "no",
  FI = "fi",
}

export enum Locales {
  GB = "en_GB",
  US = "en_US",
  DE = "de_DE",
  AT = "de_AT",
  ES = "es_ES",
  FR = "fr_FR",
  DK = "da_DK",
  SE = "sv_SE",
  NO = "no_NO",
  FI = "fi_FI",
}

export enum Countries {
  US = "US",
  GB = "GB",
  DE = "DE",
  AT = "AT",
  ES = "ES",
  FR = "FR",
  DK = "DK",
  SE = "SE",
  NO = "NO",
  FI = "FI",
}

export enum Partners {
  ADVOCARD = "advocard",
  ITZ = "itz",
  AMD = "amd",
  TFR = "tfr",
}

export enum PartnerPromoCodes {
  ADVOCARD_KUNDE = "advocard-kunde",
  ADVOCARD_AGENT = "advocard-agent",
  ITZ = "itz",
  ITZ_TEST = "itz_test",
  AMD = "amd",
  AMD_TEST = "amd_test",
  TFR = "tfr",
}

export type PartnerLogo = {
  path: string;
  width: number;
  height: number;
  headerWidth?: number;
  headerHeight?: number;
};

export enum FlightStatus {
  Unknown = "unknown",
  Delayed = "delayed",
  Cancelled = "cancelled",
  OnTime = "on_time",
}

export type ThemeProvider = {
  [key in keyof typeof Brand as string]?: any;
};

export type BrandName = {
  brandName: Brand;
};

export interface CamundaVariable {
  value: string | number;
  name: string;
  createTime: string | Date;
}

export type CamundaVariablesDto = CamundaVariable[];

export enum ActionType {
  UNSUBSCRIBE = "unsubscribe",
}

export interface FlightSearchResult {
  flightNumber: string;
  scheduledDeparture: string;
  scheduledArrival: string;
  actualDeparture: string | undefined;
  actualArrival: string | undefined;
  segmentId: number;
  operatingSegmentId: number;
  operatingFlightId: number;
  operatingFlightNumber: number;
  legNumber: number;
  arrivalAirportId: number;
  departureAirportId: number;
  status: string;
  sourceId: number;
  arrivalAirportIata: string;
  arrivalAirportName: string;
  departureAirportIata: string;
  departureAirportName: string;
  operatingAirlineId: number;
  operatingAirlineCode: string;
  operatingAirlineName: string;
  aircraftOwnerAirlineId: number;
  aircraftOwnerAirlineCode: string;
  aircraftOwnerAirlineName: string;
  codeshareFlights: [
    {
      airlineId: number;
      airlineName: string;
      designator: string;
      flightNumber: string;
      operatingSegmentId: number;
      flightId: number;
      codeShareName: string;
      codeShareDescription: string;
    }
  ];
  departureAirportCountry: string;
  arrivalAirportCountry: string;
  aircraftOperatorHeadquarterCountry: string;
  claimOpponent: string;
  placeOfJurisdiction: string;
}

export interface SelectedFlight {
  routeOrder: number;
  flightNumber: string;
  departureAirportIata: string;
  arrivalAirportIata: string;
  scheduledDepartureDateTime: string;
  scheduledArrivalDateTime: string;
  actualDepartureDateTime: string | undefined;
  actualArrivalDateTime: string | undefined;
  isTransportTaken: boolean;
  incident: string;
}

export interface FlightInfoSelectProblem {
  originIATA: string;
  destinationIATA: string;
  flightProblem: FlightProblem;
  actualArrivalTime?: string;
}

export enum TransportType {
  plane = "plane",
  train = "train",
  bus = "bus",
}

export enum TransportDataSource {
  FlightDataApi = "flight-data-api",
  Manual = "manual",
}

export enum JourneyType {
  MultiLeg = "MULTILEG",
  SingleLeg = "SINGLELEG",
}

export interface SelectedTransport {
  transportRouteOrder: string;
  transportTypeName: TransportType;
  departureAirportIata: string;
  arrivalAirportIata: string;
  transportDataSource: TransportDataSource;
  airlineIata: string | undefined;
  flightNumber: string | undefined;
  scheduledDepartureDateTime: string;
  scheduledArrivalDateTime: string;
  actualDepartureDateTime: string | undefined;
  actualArrivalDateTime: string | undefined;
}

export interface ManualTransport {
  transportRouteOrder: number;
  flightNumber: string | undefined;
  scheduledDepartureTime: string;
  scheduledArrivalTime: string;
  departureAirportIata: string;
  arrivalAirportIata: string;
  transportTypeName: TransportType;
  airlineIata: string | undefined;
}

interface TransportProps {
  departureDate: string;
  originAirportData: { iata: string; name: string };
  destinationAirportData: { iata: string; name: string };
  transportOrder: number;
  transportType: TransportType;
  transportsFieldKey: string;
  disableFutureDates?: boolean;
  defaultTransport?: SelectedTransport | FlightSearchResult;
  onDateUpdate: (newDate: string) => void;
}

export interface TransportRef {
  updateDate: (newDate: string) => void;
}

export interface TransportHOCProps {
  field: TransportProps;
}

export interface Stopover {
  name: string;
  iata: string;
  mode: TransportType;
}

export interface AlternativeRouteComponent {
  departure: AirportData;
  arrival: AirportData;
  transportationMode: TransportType;
}

export interface TrustpilotConfig {
  className?: string;
  locale: string;
  trustpilotTemplateId: string;
  trustpilotBusinessUnitId: string;
  trustpilotReviewsURL: string;
  trustpilotLinkTitle: string;
  theme: string;
  height: string;
  width: string;
}

export interface TrustpilotLayout {
  sidebar: TrustpilotConfig;
  header: TrustpilotConfig;
}

interface ApiErrorProps {
  url: string;
  status: number | string;
  statusText: string;
  data: any;
}

export function isApiError(error: any): error is ApiError {
  return error.dd_fingerprint && error.dd_fingerprint === "api-error";
}

export class ApiError extends Error {
  constructor({ url, status, statusText, data }: ApiErrorProps) {
    super(`Failed to fetch camunda API
      # url: ${url}
      # status: ${status}
      # statusText: ${statusText}
      # data: ${data}
    `);

    this.url = url;
    this.status = status;
    this.statusText = statusText;
    this.dd_fingerprint = "api-error";
  }

  public url: string = "https://www.flightiright.de";
  public status: number | string = 404;
  public statusText: string = "Not Found";
  // TODO: Find the way to bind fingerprint with datadog
  public dd_fingerprint = "api-error";
}

export interface ApiErrorResponse {
  message: string;
  error?: Error;
}

export interface Airline {
  id: number;
  iata: string;
  icao: string;
  legalNameShort: string;
  legalName: string;
  addressStreet: string;
  addressZip: string;
  addressCity: string;
  addressCountry: object;
  country: object;
  isEu: boolean;
  isUk: boolean;
  name: string;
  eu: boolean;
  uk: boolean;
  bankrupt: boolean;
}

export interface Airport {
  id: number;
  iata: string;
  icao: string;
  latitude: number;
  longitude: number;
  valid: true;
  urlName: string;
  nameDe: string;
  nameEn: string;
  nameFr: string;
  nameIt: string;
  nameEs: string;
  name: string;
  createdAt: number;
  lastModified: number;
  country: object;
  relatedAirports: Array<any>;
}

export class FileData {
  public type: string = "File";
  public valueInfo = {
    filename: "",
    mimeType: "",
  };

  constructor(fileName: string, mimeType: string) {
    this.valueInfo.filename = fileName;
    this.valueInfo.mimeType = mimeType;
  }
}

export class SignatureData extends FileData {
  public signature: string;

  constructor(base64Signature: string) {
    super("signature.png", "image/png");
    this.signature = base64Signature;
  }
}

export type FileUploadData = {
  uuid: string | null;
  fileSize: number;
  fileName: string;
  loading: boolean;
  mimeType: string;
};

export type BlobWrapper = {
  name: string;
  blob: Blob;
};

export interface UserInfo {
  ipAddress: string;
  userAgent: string;
}

export interface MediaLogo {
  logo: string;
  width?: number;
  height?: number;
}

export interface TrustLogo {
  logo: string;
  width?: number;
  height?: number;
}

export interface CreateCaseResponse {
  legalCaseId: string | null;
  legalCasePublicId: string | null;
  encryptedLegalCaseId: string | null;
}

export interface CreateDocResponse {
  id: string;
  passengers: AdditionalPassengersData[];
}
export interface Address {
  country?: string | null;
  city?: string | null;
  street?: string | null;
  postalCode?: string | null;
  fullAddress?: string | null;
}

export interface AdditionalPassengersData {
  id: string;
  salutation: string;
  firstName: string;
  lastName: string;
  minor: boolean | null;
  signature: PassengerSignatureProps | null;
  address: Address | null;
}

export interface AdditionalPassengerProps extends AdditionalPassengersData {
  passengerAvailable: string;
  signatureComponent?: SignatureData | undefined;
  sameAddress?: string | null;
  addressStreet?: string | null;
  addressPostalCode?: string | null;
  addressCity?: string | null;
  addressCountry?: string | null;
}

export interface PassengerSignatureProps {
  base64EncodedSignature: string;
  ip: string;
  userAgent: string;
  timeZone: string | null;
  signedAt: number;
}

export interface PassengersInformation {
  id: string;
  address: Address | null;
  signature: PassengerSignatureProps | null;
}

export interface FlightDataEntry {
  flightSearchResult?: FlightSearchResult;
  connectionIsMissed?: boolean;
}

export interface TargetingData {
  partnerClickId?: string | null;
  initialURL?: string | null;
  utm_source?: string | null;
}

export type DocumentPreviewLinkRequestParams = {
  caseNumber: string;
  firstName: string;
  lastName: string;
  street: string;
  city: string;
  postcode: string;
  docFileUuid: string;
  docPreviewLink: string;
};

export enum LegalArea {
  DEFAULT = "apr",
  APR = "apr",
  MIE = "mie",
  ARB = "arb",
}

export enum FlowType {
  APR = "lead-gen-flow-v4",
  APR_VAR = "lead-gen-flow-v4-var",
  MIE = "ALL_MIE_v1",
  ARB = "ALL_ARB_v1", // TODO: CHANGE IT ACCORDING TO THE FLOW NAME
}

export const FlightrightBrandDomains: Partial<Record<Domains, string>> = {
  [Domains.DE]: "flightright.de",
  [Domains.COM]: "flightright.com",
  [Domains.UK]: "flightright.co.uk",
  [Domains.AT]: "flightright.at",
  [Domains.ES]: "flightright.es",
  [Domains.SE]: "flightright.se",
  [Domains.FR]: "flightright.fr",
};

export const FlyhjaelpBrandDomains: Partial<Record<Domains, string>> = {
  [Domains.DK]: "flyhjaelp.dk",
  [Domains.NO]: "flyhjelp.no",
  [Domains.SE]: "flyghjalp.se",
  [Domains.COM]: "refundmore.com",
  [Domains.FI]: "lentoapu.fi",
};

export const FlugrechtDomains: Partial<Record<Domains, string>> = {
  [Domains.DE]: "flugrecht.de",
};

export const AllrightDomains: Partial<Record<Domains, string>> = {
  [Domains.DE]: "allright.de",
};

export const ChevalierDomains: Partial<Record<Domains, string>> = {
  [Domains.DE]: "kanzlei-chevalier.de",
};

export enum DocumentProperties {
  documentType = "cma-document-type",
  documentSubtype = "cma-document-subtype",
}

export enum LoaderState {
  WAITING = "waiting",
  LOADING = "loading",
  DONE = "done",
}

export enum CamundaSignalStatus {
  COMPLETED = "completed",
  ERROR = "error",
}

export interface CamundaEvent {
  activityType: string;
  processDefinitionKey: string;
  processInstanceId: string;
  startTime: string;
  endTime: string;
  canceled: boolean;
}
